module.exports = __webpack_public_path__ + "static/background-354089f439c2ace9f841a292a9ff73ea.svg";